import createRequestTypes from "../../../helpers/createReduxActionTypes";

export const ERROR_STATE = "ERROR_STATE";
export const GET_RECIPES = createRequestTypes("GET_RECIPES");
export const CREATE_RECIPES = createRequestTypes("CREATE_RECIPES");
export const DUPLICATE_RECIPES = createRequestTypes("DUPLICATE_RECIPES");
export const UPDATE_RECIPE = createRequestTypes("UPDATE_RECIPE");
export const DELETE_RECIPES = createRequestTypes("DELETE_RECIPES");
